import React from 'react'
import PropTypes from 'prop-types'
import style from './tag.mod.scss'

const Tag = ({
  children = 'New',
  className = '',
  tagClassName = '',
  inline = false
}) => {
  const wrapperClassNames = [style.tagWrapper]
  const tagClassNames = [style.tag]

  if (className) {
    wrapperClassNames.push(className)
  }

  if (inline) {
    wrapperClassNames.push(style.tagWrapperInline)
  }

  if (tagClassName) {
    tagClassNames.push(tagClassName)
  }

  return (
    <span className={wrapperClassNames.join(' ')}>
      <span className={tagClassNames.join(' ')}>{children}</span>
    </span>
  )
}

Tag.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  tagClassName: PropTypes.string,
  inline: PropTypes.bool
}

export default Tag
